import { useState, useEffect } from "react"
import { getSweepsByWardAndZone } from "../API/ApiService"
import { Formik, Form, Field, ErrorMessage } from "formik";


export default function SweepDisplayComponent() {

    const [wardZone, setWardZone] = useState(false)

    const [ward, setWard] = useState(0)

    const [zone, setZone] = useState(0)

    const [sweeps, setSweeps] = useState([[]])

    function handleSubmit(values, { resetForm }) {

        if (values.ward !== 0 && values.zone !== 0) {
            setWard(values.ward)
            setZone(values.zone)
            setWardZone(true)
            refreshSweeps(values.ward, values.zone)
        }

        resetForm()
}

    function refreshSweeps(ward, zone) {
        getSweepsByWardAndZone(ward, zone)
            .then(response => {

                setSweeps(response.data)
                
            })
            .catch(error => console.log(error))
    }


    function validate(values) {
        const errors = {}
        if (values.ward < 1 || values.ward > 50) {
            errors.ward = "Enter a valid ward."
        }
        if (values.zone < 1 || values.zone > 32) {
            errors.zone = "Enter a valid zone."
        }
        return errors;
    }

    return (
        <div className="showsweep">
            {!wardZone && <div className="showsweep1">
                <div className="showsweeptitle">Enter your ward and zone to display sweep dates for your area:</div>
                <Formik
                    initialValues={{ ward: 1, zone: 1 }}
                    validate={validate}
                    onSubmit={handleSubmit}
                    validateOnBlur={false}
                    validateOnChange={false}>
{() => (
    <Form className="showsweepform">
        <ErrorMessage name="ward" component="div" />
        <ErrorMessage name="zone" component="div" />

        <div className="showsweepward">
            <label htmlFor="ward">Ward: </label>
            <Field
                className="sweepward"
                id="ward"
                name="ward"
                type="number"
                min={1}
                max={50}
                step={1}
                required
                data-dashlane-disabled-on-field="true"
            />
        </div>

        <div className="showsweepzone">
            <label htmlFor="zone">Zone: </label>
            <Field
                className="sweepzone"
                id="zone"
                name="zone"
                type="number"
                min={1}
                max={32}
                step={1}
                required
                data-dashlane-disabled-on-field="true"
            />
        </div>

        <div className="showsweepsubmit">
            <button type="submit" className="submitbutton">
                Submit
            </button>
        </div>

        <div className="showsweepnull">
            If the ward and zone you enter does not exist, the table will be blank.
        </div>
    </Form>
)}
</Formik></div>}


            {wardZone && 
                <div className="showsweep2">
                    <table className="showsweeptable">
                    <thead>
                        <tr>
                            <th className="sweepheader" colSpan={8} style={{padding:'20px'}}>Sweep Dates for Ward {ward}, Zone {zone}:</th>
                        </tr>
                        <tr className="fulltext">
                            <th>April</th>
                            <th>May</th>
                            <th>June</th>
                            <th>July</th>
                            <th>August</th>
                            <th>September</th>
                            <th>October</th>
                            <th>November</th>
                        </tr>
                        <tr className="shorttext">
                            <th>Apr</th>
                            <th>May</th>
                            <th>Jun</th>
                            <th>Jul</th>
                            <th>Aug</th>
                            <th>Sep</th>
                            <th>Oct</th>
                            <th>Nov</th>
                        </tr>
                    </thead>
                    <tbody>
                            {sweeps.map((row, index) => (
                                <tr key={index}>
                                    {row.map(sweep => (
                                        <td key={sweep.id}>
                                            {sweep?.date ? sweep.date : ""}
                                        </td>
                                    ))}
                                </tr>
                            ))}                     
                            
                    </tbody>
                </table>
                <div className="refreshsweeps"><div >Refresh the page to show sweeps for another ward and zone.</div></div>
                </div>

                }
        </div>
    )


}


// {Array.from({ length: rowCount }).map((_, rowIndex) => (
//                             <tr key={rowIndex}>
//                                 {grouped.map((monthList, colIndex) => (
//                                     <td key={colIndex}>
//                                         {monthList[rowIndex] ?? ""}
//                                     </td>
//                                 ))}
//                             </tr>
//                         ))}


    // <tbody>
    //     {sweeps[0].map((_, rowIndex) => (
    //         <tr key={sweeps[0][rowIndex]}>
    //             {sweeps.map((column, colIndex) => (
    //                 <td key={colIndex}>
    //                 {column[rowIndex] ? column[rowIndex] : ""}</td>
    //             ))}

    //         </tr>
    //     ))}



    // </tbody>